export const THUMBNAIL_WIDTH = 78;
export const THUMBNAIL_HEIGHT = 108;
export const CATEGORY_IMAGE_PRODUCT_WIDTH = 400;
export const CATEGORY_IMAGE_PRODUCT_HEIGHT = 550;
